/**
 * List Schema of CargaTransfolha
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaTransfolha} from '@/model/resource/CargaTransfolha'

/* TODO: review generated schema */
export class ListCargaTransfolhaSchema extends Schema {
  readonly name = 'ListCargaTransfolha'

  readonly fieldSet: FieldSet<CargaTransfolha> = {
    idCargaTransfolhaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    pedido: (): FieldComponent => ({
      is: Component.Render,
    }),
    lote: (): FieldComponent => ({
      is: Component.Render,
    }),
    lastIdCodigo: (): FieldComponent => ({
      is: Component.Render,
    }),
    dateLastEvent: (): FieldComponent => ({
      is: Component.Render,
    }),
    hourLastEvent: (): FieldComponent => ({
      is: Component.Render,
    }),
    lastDateTry: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.lastDateTry),
      },
    }),
  }
}
